export default __webpack_public_path__ + "static/media/game_results_banner.9fde3dbd.png";